import { Link } from "react-router-dom";

const projects = [
  {
    id: "1",
    src: "/AutoHaus-1.png",
    alt: "AutoHaus",
    title: "AutoHaus",
    tags: ["Brand Identity", "Web Design"],
    height: "h-[250px]",
  },
  {
    id: "2",
    src: "/cms14.jpeg",
    alt: "Creative Summer Summit",
    title: "Creative Summer Summit",
    tags: ["Brand Identity", "Motion"],
    height: "h-[300px]",
  },
  {
    id: "3",
    src: "/crunchies.jpg",
    alt: "Crunchies",
    title: "Crunchies Fried Chicken",
    tags: ["Brand Identity", "Illustration"],
    height: "h-[220px]",
  },
  {
    id: "4",
    src: "/bistro.jpg",
    alt: "Bistro",
    title: "Birtro23",
    tags: ["Brand Identity", "Packaging"],
    height: "h-[180px]",
  },
  {
    id: "5",
    src: "/roots.jpg",
    alt: "Roots Restaurant",
    title: "Roots Restaurant",
    tags: ["Brand Identity", "Strategy"],
    height: "h-[330px]",
  },
  {
    id: "6",
    src: "/Maskgroup6.jpg",
    alt: "Disney+ App Design",
    title: "Disney+ Concept",
    tags: ["UI Design", "Motion"],
    height: "h-[280px]",
  },
  {
    id: "7",
    src: "/bofa.png",
    alt: "Bank of America",
    title: "BofA Mobile",
    tags: ["Brand Identity", "Illustration"],
    height: "h-[300px]",
  },
  {
    id: "8",
    src: "/hibex.png",
    alt: "Hibex Branding",
    title: "Hibex",
    tags: ["Brand Identity", "Naming", "Illustration"],
    height: "h-[280px]",
  },
  {
    id: "9",
    src: "/Maskgroup7.jpg",
    alt: "Hook Brand",
    title: "Hook",
    tags: ["Brand Identity", "Motion"],
    height: "h-[180px]",
  },
  {
    id: "10",
    src: "/Maskgroup8.jpg",
    alt: "Disney+ mirrored",
    title: "Disney+ Alt",
    tags: ["UI Design"],
    height: "h-[290px]",
  },
  {
    id: "11",
    src: "/Maskgroup9.jpg",
    alt: "Petrol station mirrored",
    title: "Petro Alt",
    tags: ["Brand Identity", "Packaging"],
    height: "h-[320px]",
  },
  {
    id: "12",
    src: "/Maskgroup10.jpg",
    alt: "Mobile banking mirrored",
    title: "PayEasy Alt",
    tags: ["Brand Identity", "Web Design"],
    height: "h-[350px]",
  },
];

const ProjectCard = ({
  id,
  src,
  alt,
  title,
  tags,
  height,
}) => (
  <Link to={`/project/${id}`} className="group block">
    
    {/* Image Container */}
    <div className={`overflow-hidden rounded-lg ${height}`}>
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
      />
    </div>

    {/* Text */}
    <div className="mt-1.5">
      <p className="text-sm font-medium text-gray-900 tracking-tight">
        {title}
      </p>

      <p className="text-xs text-gray-400 mt-0.5 tracking-wide">
        {tags.join("\u00a0\u00a0")}
      </p>
    </div>
  </Link>
);

export default function Work() {
  const col1 = projects.filter((_, i) => i % 3 === 0);
  const col2 = projects.filter((_, i) => i % 3 === 1);
  const col3 = projects.filter((_, i) => i % 3 === 2);

  return (
    <section className="py-10">
      <div className="sm:w-11/12 mx-auto px-4 sm:px-0">

        {/* Mobile */}
        <div className="flex flex-col gap-4 sm:hidden">
          {projects.map((p) => (
            <ProjectCard key={p.id} {...p} />
          ))}
        </div>

        {/* Desktop Masonry */}
        <div className="hidden sm:grid grid-cols-3 gap-x-2">
          {[col1, col2, col3].map((col, ci) => (
            <div key={ci} className="flex flex-col gap-4">
              {col.map((p) => (
                <ProjectCard key={p.id} {...p} />
              ))}
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}